import { render, staticRenderFns } from "./StatementResidentContact.vue?vue&type=template&id=082f85ae&scoped=true&"
import script from "./StatementResidentContact.vue?vue&type=script&lang=ts&"
export * from "./StatementResidentContact.vue?vue&type=script&lang=ts&"
import style0 from "./StatementResidentContact.vue?vue&type=style&index=0&id=082f85ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f85ae",
  null
  
)

export default component.exports